module.exports = __webpack_public_path__ + "img/box-arrow-left.79ed7229.svg";